import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause--banner",
  "use": "icon-pause--banner-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-pause--banner\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M26 1H2a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM2 0a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm9.5 8a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 .5-.5Zm6.5.5a.5.5 0 0 0-1 0v11a.5.5 0 0 0 1 0v-11Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol